<template>
  <div :style="cssProps" :id="identifier" class="select-component">
    <div v-if="title.trim().length" class="title-select">
      {{ title
      }}<font-awesome-icon
        v-if="rules.required"
        :icon="['fas', 'circle']"
        class="icon-font"
      />
    </div>
    <div
      class="custom-select"
      :tabindex="tabindex"
      @blur="closeSelect,validate"
      :style="{
        'background-color': disabled ? '#F2F2F2' : backgroundColor,
      }"
    >
      <div
        :class="['selected', { open: isSelectOpen }]"
        @click="toggleSelectOpen"
        :style="{
          'background-color': disabled ? '#F2F2F2' : backgroundColor,
          color: selectedValue && selectedValue.value.length ? '#000' : '#a5a5a5',
        }"
      >
        <slot v-if="hasIcon" name="icon"></slot>
        {{
          selectedValue && selectedValue.value
            ? selectedValue.label || selectedValue.name
            : placeholderText
        }}
      </div>
      <div :class="['options', { hide: !isSelectOpen }]">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="option"
          @click="selectOption(option)"
        >
          {{ option.label || option.name }}
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <p style="color: red" v-if="show">{{ messageError }}</p>
    </transition>
  </div>
</template>

<script>
import { validateInput } from '@/utils/rules/input';
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            defoult: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        identifier: {
            type: String,
            default: '',
        },
        selectLabel: {
            type: String,
            default: '',
        },
        defaultValue: {
            type: String,
            default: '',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: false,
        },
        hasIcon: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: Number,
            default: 0,
        },
        placeholderText: {
            type: String,
            default: '',
        },
        selectValue: {
            type: String,
            default: '',
        },
        backgroundColor: {
            type: String,
            default: '#FFF',
        },
        rules: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        selectedValue: undefined,
        isSelectOpen: false,
        show: false,
        messageError: '',
        sucess: false,
    }),
    created() {
        if (this.options.length) {
            this.selectedValue = this.defaultValue
                ? this.defaultValue
                : this.options.length > 0
                    ? String(this.options[0].value)
                    : null;
            this.$emit('input', this.selectedValue);
        }

        const array = this.options.filter((s) => {
            if (s.value == this.selectValue) return s;
        });
        this.selectedValue = array[0];
    },
    mounted: function () {
        if (this.options.length) {
            this.selectedValue = this.defaultValue
                ? this.defaultValue
                : this.options.length > 0
                    ? String(this.options[0].value)
                    : null;
            this.$emit('input', this.selectedValue);
        }

        const array = this.options.filter((s) => {
            if (s.value == this.selectValue) return s;
        });
        this.selectedValue = array[0];
    },
    methods: {
        validate() {
            if (!Object.keys(this.rules).length) {
                return false;
            }
            this.messageError = validateInput(this.rules, this.selectedValue != undefined ? String(this.selectedValue.value) : '');
            if (this.messageError.trim('').split('').length) {
                this.sucess = false;
                this.show = true;
            } else {
                this.show = false;
                this.sucess = true;
            }
            this.$emit('valid', !this.show);
        },
        toggleSelectOpen() {
            if (!this.disabled) this.isSelectOpen = !this.isSelectOpen;
        },
        openSelect() {
            this.isSelectOpen = true;
        },
        closeSelect() {
            this.isSelectOpen = false;
        },
        selectOption(option) {
            this.selectedValue = option;
            this.closeSelect();
            this.$emit('input', this.selectedValue);
        },
    },
    computed: {
        cssProps() {
            return {
                '--scroll': this.options.length > 4 ? 'scroll' : 'hiden',
                '--height': this.options.length > 4 ? '250px' : 'none',
                '--colorCircle': this.show ? 'red' : '#007BFF',
                '--colorCircleText': this.show ? 'red' : 'none',
                '--fontColor':
          this.selectedValue != undefined && !this.disabled ? '#000' : '#a5a5a5',
            };
        },
    },
    watch: {
        valid: {
            deep: true,
            handler() {
                this.validate();
            },
        },
        selectValue(newValue, oldValue) {
            const value = newValue != 'undefined' ? newValue : oldValue;
            const array = this.options.filter((s) => {
                if (s.value == value) return s;
            });
            this.selectedValue = array[0];
        },
    },
};
</script>

<style src="vue-advanced-search/dist/AdvancedSearch.css"></style>
<style>
.title-select {
  margin-left: 5px;
  margin-bottom: 5px;
  font-size: 14px;
  color: var(--colorCircleText);
}
.icon-font {
  font-size: 12px;
  padding-left: 5px;
  padding-bottom: 1px;
  color: var(--colorCircle);
}
.select-component {
  --select-height: 48px;
}

.select-component .select-input.has-icon {
  padding-left: 54px;
}
.select-component i {
  color: #a5a5a5 !important;
  font-weight: 600 !important;
  margin-right: 18px;
  position: relative;
}

.select-component .custom-select {
  background-color: #f7f7f7;
  border-radius: 3px;
  height: var(--select-height);
  line-height: var(--select-height);
  outline: none;
  position: relative;
  text-align: left;
  width: 100%;
}
.select-component .custom-select .selected {
  background-color: #f7f7f7;
  border-radius: 3px;
  border: 1px solid #dbdbdb;
  color: var(--fontColor);
  cursor: pointer;
  height: var(--select-height);
  padding-left: 1em;
  user-select: none;
  color: black !important ;
}
.select-component .custom-select .selected.open {
  border-radius: 3px 3px 0px 0px;
}
.select-component .custom-select .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #dbdbdb transparent transparent transparent;
}
.select-component .custom-select .selected.open:after {
  transform: scaleY(-1);
  top: 16px;
}
.select-component .custom-select .options {
  background-color: #fff;
  border-radius: 0px 0px 3px 3px;
  box-shadow: 0px 3px 6px #00000029;
  color: #a5a5a5;
  left: 0;
  overflow-y: var(--scroll);
  position: absolute;
  right: 0;
  z-index: 1;
  max-height: var(--height);
}
.select-component .custom-select .options .option {
  color: #a5a5a5;
  cursor: pointer;
  padding-left: 16px;
  user-select: none;
}
.select-component .custom-select .options .option:hover {
  background-color: var(--color--light-blue);
  color: #fff;
}

@media screen and (max-width: 1366px) {
  .select-component {
    --select-height: 40px;
  }
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 992px) {
}
</style>
